module.exports = __webpack_public_path__ + "static/media/logo.672e3041.png";